import { z } from 'zod';
// Valid job types
export const SITE_JOB_TYPES = ['provision', 'rebuild', 'migrate_visual', 'migrate_97d', 'migrate_wordpress'];
// Valid statuses
export const SITE_JOB_STATUSES = ['pending', 'validating', 'queued', 'converting', 'building', 'deploying', 'live', 'failed', 'cancelled'];
// Valid status transitions (from → to[])
export const VALID_TRANSITIONS = {
    pending: ['validating', 'queued', 'failed', 'cancelled'],
    validating: ['queued', 'failed', 'cancelled'],
    queued: ['converting', 'failed', 'cancelled'],
    converting: ['building', 'failed', 'cancelled'],
    building: ['deploying', 'failed', 'cancelled'],
    deploying: ['live', 'failed', 'cancelled'],
    // Terminal states — no further transitions
    live: [],
    failed: [],
    cancelled: [],
};
// Domain pattern: lowercase alphanumeric + dots + hyphens only (shell injection prevention)
const domainPattern = /^[a-z0-9][a-z0-9.-]*[a-z0-9]$/;
// Create a site job
export const createSiteJobSchema = z.object({
    org_id: z.string().uuid(),
    job_type: z.enum(SITE_JOB_TYPES),
    source_url: z.string().url().max(2000).optional(),
    target_domain: z.string().regex(domainPattern, 'Invalid domain format').max(255).optional(),
    target_site_name: z.string().regex(/^[a-z0-9-]+$/, 'Lowercase alphanumeric + hyphens only').max(100).optional(),
    site_config: z.record(z.unknown()).optional(),
});
// Update job status (from migration-worker or 98agents)
export const updateSiteJobStatusSchema = z.object({
    status: z.enum(SITE_JOB_STATUSES),
    progress: z.object({
        step: z.string().max(50).optional(),
        detail: z.string().max(500).optional(),
        stdout: z.string().max(5000).optional(),
        stderr: z.string().max(5000).optional(),
        exit_code: z.number().int().optional(),
    }).optional(),
    error_message: z.string().max(2000).optional(),
    error_stage: z.string().max(30).optional(),
    claimed_by: z.string().max(100).optional(),
    webengine_server: z.string().max(50).optional(),
});
// Pre-flight validation request
export const validateSiteJobSchema = z.object({
    job_type: z.enum(SITE_JOB_TYPES),
    source_url: z.string().url().max(2000).optional(),
    target_domain: z.string().regex(domainPattern, 'Invalid domain format').max(255).optional(),
    org_id: z.string().uuid(),
});
// List/query filters
export const listSiteJobsSchema = z.object({
    org_id: z.string().uuid().optional(),
    status: z.enum(SITE_JOB_STATUSES).optional(),
    job_type: z.enum(SITE_JOB_TYPES).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(20),
    offset: z.coerce.number().int().min(0).default(0),
});
/**
 * Check if a status transition is valid.
 */
export function isValidTransition(from, to) {
    return VALID_TRANSITIONS[from]?.includes(to) ?? false;
}
//# sourceMappingURL=site-jobs.js.map